import { getParameter } from '@bingads-webui/url-util';
import { GoogleLoginRepository as GoogleLoginBaseRepository } from '@bingads-webui/google-login-repository';

// OAuth scopes needed to call Google's Content API for shopping, and to get the user's email
const OAUTH_SCOPE = 'https://www.googleapis.com/auth/content https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';

// GMC is Google Merchant Center: https://www.google.com/intl/en_us/retail/solutions/merchant-center/
export class GMCLoginRepository extends GoogleLoginBaseRepository {
  constructor(deps) {
    const { google, clientId, GSILocal } = deps;
    super({
      scope: OAUTH_SCOPE,
      clientId,
      GSILocal,
      google,
    });
  }

  googleSignIn({
    onSuccess,
    onFail,
    useConsentPrompt,
  }) {
    const isSelenium = getParameter('isselenium');

    // Covered by SI E2E tests
    /* istanbul ignore next */
    if (isSelenium) {
      const testGMCAccount = getParameter('testGMCAccount');
      const response = {
        testGMCAccount,
        code: null,
      };

      // onSignInSuccess -> generateMappingGridRows -> getMappings -> generateGetMappingsRequest
      // In generateGetMappingsRequest, we'll use testGMCAccount
      onSuccess(response);
      return;
    }

    super.googleSignIn({
      onSuccess,
      onFail,
      useConsentPrompt,
    });
  }
}
